import { render, staticRenderFns } from "./ProcessWorkPermitGA.vue?vue&type=template&id=0f7b230f"
import script from "./js/ProcessWorkPermitGA.js?vue&type=script&lang=js&external"
export * from "./js/ProcessWorkPermitGA.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports